import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import {AlarmTile, Tile} from "../models";

@Pipe({
    name: 'tilesOrder'
})
export class TilesOrderPipe implements PipeTransform {

    transform(tiles: Array<AlarmTile | Tile>): Array<AlarmTile | Tile> {
        const filteredTiles = tiles.filter(tile => tile.visibility);

        return _.orderBy(filteredTiles, ['orderId', 'type']);
    }
}
